module.exports = __webpack_public_path__ + "img/product.e9833dd6.png";